import { Component, Input, OnInit } from "@angular/core";
import {
  StructuredDiagnosisColumnItem,
  StructuredDiagnosisColumn,
} from "../../../model/study-report-text";

@Component({
  selector: "app-structured-diagnosis-panel",
  templateUrl: "./structured-diagnosis-panel.component.html",
  styleUrls: ["./structured-diagnosis-panel.component.css"],
})
export class StructuredDiagnosisPanelComponent implements OnInit {
  @Input() allItemSelected: StructuredDiagnosisColumnItem[] = [];
  @Input() allColumns: StructuredDiagnosisColumn[] = [];

  columns: StructuredDiagnosisColumn[] = [];

  ngOnInit(): void {
    this.allColumns[0].Index = 0;
    this.columns.push(this.allColumns[0]);
    this.checkFirstSelected(this.allColumns[0]);
  }

  itemSelected(
    index: number,
    item: StructuredDiagnosisColumnItem,
    removeOrAdd: boolean = true
  ): void {
    this.columns[index].Items.forEach((i) => (i.IsClicked = false));
    item.IsClicked = true;

    let isNext = this.isNextStep(index, item);
    let isRemoving = false;

    if (removeOrAdd) {
      isRemoving = this.removeOrAddSelectedItem(item);
    }

    if (!isNext || isRemoving) {
      this.columns.splice(index + 1, this.columns.length);
    }

    const addNew = !isNext && !isRemoving;


    if (addNew) {
      this.addNextColumn(index, item);
    }
  }

  private removeOrAddSelectedItem(item: StructuredDiagnosisColumnItem): boolean {
    const selectedIndex = this.allItemSelected.findIndex(
      (i) => i.Id === item.Id
    );

    if (item.Id && selectedIndex > -1) {
      const withChilds =
        this.allItemSelected.findIndex((i) => i.ItemParentId === item.Id) > -1;
      if (!item.StepTargetId || !withChilds) {
        this.allItemSelected.splice(selectedIndex, 1);
        return true;
      }
    } else if (item.Id && selectedIndex === -1) {
      this.allItemSelected.push(item);
    }

    return false;
  }

  private isNextStep(index: number, item: StructuredDiagnosisColumnItem) {
    if (index < this.columns.length - 1) {
      if (this.columns[index + 1].StepId === item.StepTargetId) {
        return true;
      }
    }
    return false;
  }

  private addNextColumn(index: number, item: StructuredDiagnosisColumnItem) {
    if (item.StepTargetId) {
      const columnPaso = this.getNextColumn(index, item);
      this.columns.push(columnPaso);
      this.allColumns.push(columnPaso);
      columnPaso.Items.forEach(i => i.ColumnIndex = columnPaso.Index);
      this.checkFirstSelected(columnPaso);
    }
  }

  private checkFirstSelected(columnPaso: StructuredDiagnosisColumn) {
    const firstSelectedIndex = columnPaso.Items.findIndex((e) =>
      this.isItemSelected(e)
    );
    if (
      firstSelectedIndex > -1 &&
      columnPaso.Items[firstSelectedIndex].StepTargetId
    ) {
      this.itemSelected(
        columnPaso.Index,
        columnPaso.Items[firstSelectedIndex],
        false
      );
    }
  }

  private getNextColumn(index: number, item: StructuredDiagnosisColumnItem) {
    const newColumn = this.allColumns.find(
      (c) => c.StepId === item.StepTargetId
    );

    newColumn.Index = index + 1;
    newColumn.Items.forEach((i) => {
      i.IsClicked = false;
      i.ItemParentId = item.Id;
    });

    return newColumn;
  }

  isItemSelected(item: StructuredDiagnosisColumnItem): boolean {
    const isSelected =
      this.allItemSelected.findIndex(
        (i) =>
          ((i.ItemParentId === item.Id && !item.Id) ||
            (i.Id === item.Id && item.Id)) &&
          i.CircuitId === item.CircuitId
      ) > -1;

    return isSelected;
  }


  getText(item:  StructuredDiagnosisColumnItem): string {

    const targets = this.allItemSelected.filter(i => i.ItemParentId === item.Id);
    let text = item.Name;
    if (item.StepTargetId) {
      text =  '<b>' + item.Name + '> </b>'
    }

    let targetText: string[] = [];
    for (const target of targets) {
      var tText = this.getText(target);
      if (tText) {
        targetText.push(tText);
      }
    }

    return text + targetText.join(' - ');
  }

  getSelection(): string[] {
    let response: string[] = [];

    for (let index = 0; index < this.columns[0].Items.length; index++) {
      const circuitId = this.columns[0].Items[index].CircuitId;
      const circuitName = this.columns[0].Items[index].Name;

      const items = this.allItemSelected.filter(
        (c) => c.CircuitId === circuitId
      );

      const primeraFila = items.filter(i => i.ColumnIndex === 1);
      let text = '';

      if (primeraFila.length > 0) {
        for (let indexPrimerafila = 0; indexPrimerafila < primeraFila.length; indexPrimerafila++) {
          const element = primeraFila[indexPrimerafila];
          text = text + this.getText(element) + ' ';
        }

        response.push('<b>' + circuitName + '> </b>' + text);
      }

    }

    return response;
  }
}
